import { Navigate, Route, Routes } from "react-router-dom";
import Dashboard from "../pages/dashboard";
import ShowToast from "../components/showToast";
import Layout from "../pages/layout";
import UserMaster from "../pages/userMaster";
import LoginPage from "../pages/login";
import SDPLLoginPage from "../pages/sdpllogin";
import Engagement from "../pages/engagementPage";
import ForgetPassword from "../pages/forgetPassword";
import SDPLForgetPassword from "../pages/sdplforgetPassword";
// import CustomerExprienceProject from "../pages/customerExprience/customerExprience";
import TextWordCloud from "../pages/textWordCloud/textWordCloud";
import Touchpoint from "../pages/touchpoint/touchpoint";
import Insights from "../pages/Insights/Insights";
import Request from "../pages/request/request";
import Response from "../pages/response/response";
import JourneyMetrics from "../pages/journeyMetrics/JourneyMetrics";
import ConversationPreview from "../pages/conversation/FeedsPage";
import Recommend from "../pages/feedback/recommend";
import LabNumber from "../pages/feedback/labnumber";
import Thanks from "../pages/feedback/thanks";
import UserRoleMaster from "../pages/User/userRoleMenuMapping";
import SelectLanguage from "../pages/feedback/selectlanguage";
import LikeServices from "../pages/feedback/likeService";
import underMaintenance from "../staticComps/underMaintenence";
import FeedsPage from "../pages/conversation/FeedsPage";
import LiveFeeds from "../pages/conversation/LiveFeeds";
import ResetPassword from "../pages/Dashboard/ResetPassword";
import { useState } from "react";
import GetUserData from "../utilities/getUserDetails";
import OtpPage from "../pages/otp";
import SDPLOtpPage from "../pages/sdplotp";
//author-saksham
//function- to navigate securely throughout the application

const PageNotFound = () => {
  return <h1>404 Not Found!</h1>;
};
const ProtectedRoutes = ({ isAuth }) => {
  const [userInfo, setUserInfo] = useState(GetUserData());
  return (
    <div>
      <ShowToast />
      <Routes>
        <Route
          path="/notFound"
          element={isAuth ? <Layout page={PageNotFound} /> : <LoginPage />}
        />
        <Route
          path="/textWordCloud"
          element={isAuth ? <Layout page={TextWordCloud} /> : <LoginPage />}
        />
        <Route
          path="/textWordCloudCustomerDetails"
          element={isAuth ? <Layout page={TextWordCloud} /> : <LoginPage />}
        />
        <Route path="/home" element={isAuth ? <Dashboard /> : <LoginPage />} />
        {/* <Route
            path="/login"
            element={isAuth ? <Dashboard/> : <LoginPage />}
          /> */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/sdpllogin" element={<SDPLLoginPage />} />
        <Route path="/otp" element={<OtpPage />} />
        <Route path="/sdplotp" element={<SDPLOtpPage />} />
        <Route
          path="/forgetPassword"
          element={isAuth ? <Layout page={Dashboard} /> : <ForgetPassword />}
        />
        <Route
          path="/sdplforgetPassword"
          element={isAuth ? <Layout page={Dashboard} /> : <SDPLForgetPassword />}
        />
        <Route
          path="/resetPassword"
          element={isAuth ? <ResetPassword /> : <LoginPage />}
        />
        <Route
          path="/userMaster"
          element={
            isAuth && userInfo.UserRole === "Admin" ? (
              <Layout page={UserMaster} />
            ) : (
              <PageNotFound />
            )
          }
        />
        <Route
          path="/touchPoint"
          element={isAuth ? <Layout page={Touchpoint} /> : <LoginPage />}
        />
        <Route
          path="/engagement"
          element={isAuth ? <Layout page={Engagement} /> : <LoginPage />}
        />
        <Route
          path="/journeyMetrics"
          element={isAuth ? <Layout page={JourneyMetrics} /> : <LoginPage />}
        />
        <Route
          path="/ConversationPreview"
          element={
            isAuth ? <Layout page={ConversationPreview} /> : <LoginPage />
          }
        />
        <Route
          path="/feedsPage"
          element={isAuth ? <Layout page={FeedsPage} /> : <LoginPage />}
        />
        <Route
          path="/liveFeeds"
          element={isAuth ? <Layout page={LiveFeeds} /> : <LoginPage />}
        />
        <Route
          path="/underMaintenance"
          element={isAuth ? <Layout page={underMaintenance} /> : <LoginPage />}
        />
        <Route
          path="/userRoleMaster"
          element={
            isAuth && userInfo.UserRole === "Admin" ? (
              <Layout page={UserRoleMaster} />
            ) : (
              <PageNotFound />
            )
          }
        />
        <Route
          path="/selectLanguage"
          element={isAuth ? <Layout page={SelectLanguage} /> : <LoginPage />}
        />
        <Route
          path="/referPage"
          element={isAuth ? <Layout page={Recommend} /> : <LoginPage />}
        />
        <Route
          path="/likeService"
          element={isAuth ? <Layout page={LikeServices} /> : <LoginPage />}
        />
        <Route
          path="/labNumber"
          element={isAuth ? <Layout page={LabNumber} /> : <LoginPage />}
        />
        <Route
          path="/thanks"
          element={isAuth ? <Layout page={Thanks} /> : <LoginPage />}
        />
        <Route
          path="/insights"
          element={isAuth ? <Layout page={Insights} /> : <LoginPage />}
        />
        <Route
          path="/request"
          element={isAuth ? <Layout page={Request} /> : <LoginPage />}
        />
        <Route
          path="/response"
          element={isAuth ? <Layout page={Response} /> : <LoginPage />}
        />
        <Route path="*" element={<Navigate to={"/login"} replace={true} />} />
      </Routes>
    </div>
  );
};

export default ProtectedRoutes;
//end
